export default {
    okText: 'Ok',
    cancelText: 'Avbryt',
};
